import { render, staticRenderFns } from "./InfoMenu.vue?vue&type=template&id=0fdb64e0&scoped=true"
import script from "./InfoMenu.vue?vue&type=script&lang=js"
export * from "./InfoMenu.vue?vue&type=script&lang=js"
import style0 from "./InfoMenu.vue?vue&type=style&index=0&id=0fdb64e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb64e0",
  null
  
)

export default component.exports